import { render, staticRenderFns } from "./pushMessage.vue?vue&type=template&id=2e27ce59&scoped=true&"
import script from "./pushMessage.vue?vue&type=script&lang=js&"
export * from "./pushMessage.vue?vue&type=script&lang=js&"
import style0 from "./pushMessage.vue?vue&type=style&index=0&id=2e27ce59&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e27ce59",
  null
  
)

export default component.exports